// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__1baHj","loader":"loader_loader__EOd9Y","Table":"loader_Table__Y4q0w"};